// src/utils/errorHandler.js

export const getErrorMessage = (error) => {
  const status = error?.response?.status;

  switch (status) {
    case 400:
      return error?.response?.data?.message || "Bad Request";

    case 401:
      return error?.response?.data?.message || "Unauthorized";

    case 403:
      return error?.response?.data?.message || "Access Denied";

    case 404:
      return error?.response?.data?.message || "Resource Not Found";

    case 500:
      return error?.response?.data?.message || "Internal Server Error";

    default:
      return (
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"
      );
  }
};